import React from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import _ from 'lodash';
import cx from 'classnames';

import messages from '../../MLSummary.messages'
import styles from '../../MLSummary.module.scss'

function MLExclusions({ data, show }) {
    const translator = useTranslator();

    if (_.isEmpty(data)) {
        return null;
    }

    if (show) {
        return (
            <div className="vertical-spacing-30">
                <hr className="vertical-spacing-30" />
                <h2 className="section-header vertical-spacing-20">
                    {translator(messages.Exclusions)}
                </h2>
                <p className="vertical-spacing-20">{translator(messages.ExclusionsPara)}</p>
                {data.map((term) => {
                    return (
                        <div className="row clearfix">
                            <div className="col-md-4 vertical-spacing-10">{term.name}</div>
                        </div>
                    );
                })}
            </div>
        );
    }
    return ( <></> );
}

MLExclusions.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({})),
    show: PropTypes.bool
};
MLExclusions.defaultProps = {
    data: [],
    show: false
};
export default MLExclusions;
